"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_ATTEMPTED = exports.VIDEO_THUMBNAIL_UPDATE_SUCCEEDED = exports.VIDEO_THUMBNAIL_UPDATE_FAILED = exports.VIDEO_THUMBNAIL_UPDATE_ATTEMPTED = exports.DOWNLOAD_FROM_EXTERNAL_URL_SUCCEEDED = exports.DOWNLOAD_FROM_EXTERNAL_URL_ATTEMPTED = exports.DOWNLOAD_FROM_DRIVE_FAILED = exports.DOWNLOAD_FROM_DRIVE_SUCCEEDED = exports.DOWNLOAD_FROM_DRIVE_ATTEMPTED = exports.DOWNLOAD_FROM_DROPBOX_FAILED = exports.DOWNLOAD_FROM_DROPBOX_SUCCEEDED = exports.DOWNLOAD_FROM_DROPBOX_ATTEMPTED = exports.REMOVE_CANVA_ID_SUCCEEDED = exports.DOWNLOAD_FROM_CANVA_FAILED = exports.DOWNLOAD_FROM_CANVA_SUCCEEDED = exports.DOWNLOAD_FROM_CANVA_ATTEMPTED = exports.CANVA_INIT_FAILED = exports.CANVA_INIT_SUCCEEDED = exports.CANVA_INIT_ATTEMPTED = exports.SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED = exports.SOFT_DELETE_VIDYARD_PLAYERID_FAILED = exports.CREATE_VIDYARD_PLAYERID_FAILED = exports.CREATE_VIDYARD_PLAYERID_SUCCEEDED = exports.CREATE_VIDYARD_PLAYERID_ATTEMPTED = exports.INFERRED_USER_ROLE_FETCH_SUCCEEDED = exports.UPDATE_PORTAL_META_FAILED = exports.UPDATE_PORTAL_META_SUCCEEDED = exports.UPDATE_PORTAL_META_ATTEMPTED = exports.FETCH_FILE_MANAGER_PORTAL_DATA_SUCCEEDED = exports.UPDATE_VIDYARD_TOS_STATUS_FAILED = exports.UPDATE_VIDYARD_TOS_STATUS_SUCCEEDED = exports.UPDATE_VIDYARD_TOS_STATUS_ATTEMPTED = exports.SAVE_USER_SETTINGS_ATTEMPTED = exports.FETCH_USER_SETTINGS_EMPTY = exports.FETCH_USER_SETTINGS_FAILED = exports.FETCH_USER_SETTINGS_SUCCEEDED = exports.FETCH_USER_SETTINGS_ATTEMPTED = exports.RENAME_FILE_FAILED = exports.RENAME_FILE_SUCCEEDED = exports.RENAME_FILE_ATTEMPTED = exports.MOVE_FILE_FAILED = exports.MOVE_FILE_SUCCEEDED = exports.MOVE_FILE_ATTEMPTED = exports.UNARCHIVE_FILE_FAILED = exports.UNARCHIVE_FILE_SUCCEEDED = exports.UNARCHIVE_FILE_ATTEMPTED = exports.ARCHIVE_FILE_FAILED = exports.ARCHIVE_FILE_SUCCEEDED = exports.ARCHIVE_FILE_ATTEMPTED = exports.DELETE_FILE_FAILED = exports.DELETE_FILE_SUCCEEDED = exports.DELETE_FILE_ATTEMPTED = exports.RECALCULATE_IMAGE_DIMENSIONS_SUCCESS = exports.SAVE_EDIT_FAILED = exports.SAVE_EDIT_SUCCEEDED = exports.SAVE_EDIT_ATTEMPTED = exports.REPLACE_FILE_FAILED = exports.REPLACE_FILE_SUCCEEDED = exports.REPLACE_FILE_ATTEMPTED = exports.REPLACE_FILE_PROGRESS = exports.BULK_UPLOAD_FILES_ATTEMPTED = exports.UPLOAD_FILE_FAILED = exports.UPLOAD_FILE_SUCCEEDED = exports.UPLOAD_FILE_ATTEMPTED = exports.UPLOAD_FILE_PROGRESS = exports.SEARCH_FILES_FAILED = exports.SEARCH_FILES_SUCCESS = exports.SEARCH_FILES_ATTEMPTED = exports.FETCH_SINGLE_FILE_FAILED = exports.FETCH_SINGLE_FILE_SUCCESS = exports.FETCH_SINGLE_FILE_ATTEMPTED = exports.FETCH_MORE_FILES_FAILED = exports.FETCH_MORE_FILES_SUCCEEDED = exports.FETCH_MORE_FILES_ATTEMPTED = exports.FETCH_FILES_FAILED = exports.FETCH_FILES_SUCCEEDED = exports.FETCH_FILES_ATTEMPTED = exports.BULK_MOVE_FAILED = exports.BULK_MOVE_SUCCEEDED = exports.BULK_MOVE_ATTEMPTED = exports.BULK_DELETE_FAILED = exports.BULK_DELETE_SUCCEEDED = exports.BULK_DELETE_ATTEMPTED = exports.RENAME_FOLDER_FAILED = exports.RENAME_FOLDER_SUCCEEDED = exports.RENAME_FOLDER_ATTEMPTED = exports.MOVE_FOLDER_FAILED = exports.MOVE_FOLDER_SUCCEEDED = exports.MOVE_FOLDER_ATTEMPTED = exports.DELETE_FOLDER_FAILED = exports.DELETE_FOLDER_SUCCEEDED = exports.DELETE_FOLDER_ATTEMPTED = exports.ADD_FOLDER_FAILED = exports.ADD_FOLDER_SUCCEEDED = exports.ADD_FOLDER_ATTEMPTED = exports.FETCH_FOLDER_SUCCEEDED = exports.FETCH_FOLDERS_FAILED = exports.FETCH_FOLDERS_SUCCEEDED = exports.FETCH_FOLDERS_ATTEMPTED = exports.SET_AUTH = void 0;
exports.FETCH_SUSPENSION_STATE_FAILED = exports.FETCH_SUSPENSION_STATE_SUCCEEDED = exports.FETCH_SUSPENSION_STATE_ATTEMPTED = exports.TRACK_INTERACTION = exports.CHANGE_FILE_ACCESSIBILITY_REQUEST_SUCCEEDED = exports.CHANGE_TAB = exports.RESET_PAGE = exports.ACQUIRE_IMAGE_FAILED = exports.ACQUIRE_IMAGE_SUCCEEDED = exports.ACQUIRE_IMAGE_ATTEMPTED = exports.SEARCH_SHUTTERSTOCK_FAILED = exports.SEARCH_SHUTTERSTOCK_SUCCEEDED = exports.SEARCH_SHUTTERSTOCK_ATTEMPTED = exports.SEARCH_SHUTTERSTOCK_RESET = exports.FETCH_SIGNED_URL_FAILED = exports.HUB_USERS_FETCH_FAILED = exports.HUB_USERS_FETCH_SUCCEEDED = exports.UPLOAD_EDITED_IMAGE_SUCCEEDED = exports.UPLOAD_EDITED_IMAGE_FAILED = exports.UPLOAD_EDITED_IMAGE_ATTEMPTED = exports.IMAGE_TO_EDIT_DESELECTED = exports.IMAGE_TO_EDIT_SELECTED = exports.SELECT_FILE = exports.DECREASE_VIDEO_QUANTITY_USED = exports.CONFIRM_VIDEO_UPLOAD_WITHOUT_EMBED = exports.FETCH_LIMITS_SUCCEEDED = exports.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED = exports.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_FAILED = void 0;
var SET_AUTH = 'SET_AUTH';
exports.SET_AUTH = SET_AUTH;
var FETCH_FOLDERS_ATTEMPTED = 'FETCH_FOLDERS_ATTEMPTED';
exports.FETCH_FOLDERS_ATTEMPTED = FETCH_FOLDERS_ATTEMPTED;
var FETCH_FOLDERS_SUCCEEDED = 'FETCH_FOLDERS_SUCCEEDED';
exports.FETCH_FOLDERS_SUCCEEDED = FETCH_FOLDERS_SUCCEEDED;
var FETCH_FOLDERS_FAILED = 'FETCH_FOLDERS_FAILED';
exports.FETCH_FOLDERS_FAILED = FETCH_FOLDERS_FAILED;
var FETCH_FOLDER_SUCCEEDED = 'FETCH_FOLDER_SUCCEEDED';
exports.FETCH_FOLDER_SUCCEEDED = FETCH_FOLDER_SUCCEEDED;
var ADD_FOLDER_ATTEMPTED = 'ADD_FOLDER_ATTEMPTED';
exports.ADD_FOLDER_ATTEMPTED = ADD_FOLDER_ATTEMPTED;
var ADD_FOLDER_SUCCEEDED = 'ADD_FOLDER_SUCCEEDED';
exports.ADD_FOLDER_SUCCEEDED = ADD_FOLDER_SUCCEEDED;
var ADD_FOLDER_FAILED = 'ADD_FOLDER_FAILED';
exports.ADD_FOLDER_FAILED = ADD_FOLDER_FAILED;
var DELETE_FOLDER_ATTEMPTED = 'DELETE_FOLDER_ATTEMPTED';
exports.DELETE_FOLDER_ATTEMPTED = DELETE_FOLDER_ATTEMPTED;
var DELETE_FOLDER_SUCCEEDED = 'DELETE_FOLDER_SUCCEEDED';
exports.DELETE_FOLDER_SUCCEEDED = DELETE_FOLDER_SUCCEEDED;
var DELETE_FOLDER_FAILED = 'DELETE_FOLDER_FAILED';
exports.DELETE_FOLDER_FAILED = DELETE_FOLDER_FAILED;
var MOVE_FOLDER_ATTEMPTED = 'MOVE_FOLDER_ATTEMPTED';
exports.MOVE_FOLDER_ATTEMPTED = MOVE_FOLDER_ATTEMPTED;
var MOVE_FOLDER_SUCCEEDED = 'MOVE_FOLDER_SUCCEEDED';
exports.MOVE_FOLDER_SUCCEEDED = MOVE_FOLDER_SUCCEEDED;
var MOVE_FOLDER_FAILED = 'MOVE_FOLDER_FAILED';
exports.MOVE_FOLDER_FAILED = MOVE_FOLDER_FAILED;
var RENAME_FOLDER_ATTEMPTED = 'RENAME_FOLDER_ATTEMPTED';
exports.RENAME_FOLDER_ATTEMPTED = RENAME_FOLDER_ATTEMPTED;
var RENAME_FOLDER_SUCCEEDED = 'RENAME_FOLDER_SUCCEEDED';
exports.RENAME_FOLDER_SUCCEEDED = RENAME_FOLDER_SUCCEEDED;
var RENAME_FOLDER_FAILED = 'RENAME_FOLDER_FAILED';
exports.RENAME_FOLDER_FAILED = RENAME_FOLDER_FAILED;
var BULK_DELETE_ATTEMPTED = 'BULK_DELETE_ATTEMPTED';
exports.BULK_DELETE_ATTEMPTED = BULK_DELETE_ATTEMPTED;
var BULK_DELETE_SUCCEEDED = 'BULK_DELETE_SUCCEEDED';
exports.BULK_DELETE_SUCCEEDED = BULK_DELETE_SUCCEEDED;
var BULK_DELETE_FAILED = 'BULK_DELETE_FAILED';
exports.BULK_DELETE_FAILED = BULK_DELETE_FAILED;
var BULK_MOVE_ATTEMPTED = 'BULK_MOVE_ATTEMPTED';
exports.BULK_MOVE_ATTEMPTED = BULK_MOVE_ATTEMPTED;
var BULK_MOVE_SUCCEEDED = 'BULK_MOVE_SUCCEEDED';
exports.BULK_MOVE_SUCCEEDED = BULK_MOVE_SUCCEEDED;
var BULK_MOVE_FAILED = 'BULK_MOVE_FAILED';
exports.BULK_MOVE_FAILED = BULK_MOVE_FAILED;
var FETCH_FILES_ATTEMPTED = 'FETCH_FILES_ATTEMPTED';
exports.FETCH_FILES_ATTEMPTED = FETCH_FILES_ATTEMPTED;
var FETCH_FILES_SUCCEEDED = 'FETCH_FILES_SUCCEEDED';
exports.FETCH_FILES_SUCCEEDED = FETCH_FILES_SUCCEEDED;
var FETCH_FILES_FAILED = 'FETCH_FILES_FAILED';
exports.FETCH_FILES_FAILED = FETCH_FILES_FAILED;
var FETCH_MORE_FILES_ATTEMPTED = 'FETCH_MORE_FILES_ATTEMPTED';
exports.FETCH_MORE_FILES_ATTEMPTED = FETCH_MORE_FILES_ATTEMPTED;
var FETCH_MORE_FILES_SUCCEEDED = 'FETCH_MORE_FILES_SUCCEEDED';
exports.FETCH_MORE_FILES_SUCCEEDED = FETCH_MORE_FILES_SUCCEEDED;
var FETCH_MORE_FILES_FAILED = 'FETCH_MORE_FILES_FAILED';
exports.FETCH_MORE_FILES_FAILED = FETCH_MORE_FILES_FAILED;
var FETCH_SINGLE_FILE_ATTEMPTED = 'FETCH_SINGLE_FILE_ATTEMPTED';
exports.FETCH_SINGLE_FILE_ATTEMPTED = FETCH_SINGLE_FILE_ATTEMPTED;
var FETCH_SINGLE_FILE_SUCCESS = 'FETCH_SINGLE_FILE_SUCCESS';
exports.FETCH_SINGLE_FILE_SUCCESS = FETCH_SINGLE_FILE_SUCCESS;
var FETCH_SINGLE_FILE_FAILED = 'FETCH_SINGLE_FILE_FAILED';
exports.FETCH_SINGLE_FILE_FAILED = FETCH_SINGLE_FILE_FAILED;
var SEARCH_FILES_ATTEMPTED = 'SEARCH_FILES_ATTEMPTED';
exports.SEARCH_FILES_ATTEMPTED = SEARCH_FILES_ATTEMPTED;
var SEARCH_FILES_SUCCESS = 'SEARCH_FILES_SUCCESS';
exports.SEARCH_FILES_SUCCESS = SEARCH_FILES_SUCCESS;
var SEARCH_FILES_FAILED = 'SEARCH_FILES_FAILED';
exports.SEARCH_FILES_FAILED = SEARCH_FILES_FAILED;
var UPLOAD_FILE_PROGRESS = 'UPLOAD_FILE_PROGRESS';
exports.UPLOAD_FILE_PROGRESS = UPLOAD_FILE_PROGRESS;
var UPLOAD_FILE_ATTEMPTED = 'UPLOAD_FILE_ATTEMPTED';
exports.UPLOAD_FILE_ATTEMPTED = UPLOAD_FILE_ATTEMPTED;
var UPLOAD_FILE_SUCCEEDED = 'UPLOAD_FILE_SUCCEEDED';
exports.UPLOAD_FILE_SUCCEEDED = UPLOAD_FILE_SUCCEEDED;
var UPLOAD_FILE_FAILED = 'UPLOAD_FILE_FAILED';
exports.UPLOAD_FILE_FAILED = UPLOAD_FILE_FAILED;
var BULK_UPLOAD_FILES_ATTEMPTED = 'BULK_UPLOAD_FILES_ATTEMPTED';
exports.BULK_UPLOAD_FILES_ATTEMPTED = BULK_UPLOAD_FILES_ATTEMPTED;
var REPLACE_FILE_PROGRESS = 'REPLACE_FILE_PROGRESS';
exports.REPLACE_FILE_PROGRESS = REPLACE_FILE_PROGRESS;
var REPLACE_FILE_ATTEMPTED = 'REPLACE_FILE_ATTEMPTED';
exports.REPLACE_FILE_ATTEMPTED = REPLACE_FILE_ATTEMPTED;
var REPLACE_FILE_SUCCEEDED = 'REPLACE_FILE_SUCCEEDED';
exports.REPLACE_FILE_SUCCEEDED = REPLACE_FILE_SUCCEEDED;
var REPLACE_FILE_FAILED = 'REPLACE_FILE_FAILED';
exports.REPLACE_FILE_FAILED = REPLACE_FILE_FAILED;
var SAVE_EDIT_ATTEMPTED = 'SAVE_EDIT_ATTEMPTED';
exports.SAVE_EDIT_ATTEMPTED = SAVE_EDIT_ATTEMPTED;
var SAVE_EDIT_SUCCEEDED = 'SAVE_EDIT_SUCCEEDED';
exports.SAVE_EDIT_SUCCEEDED = SAVE_EDIT_SUCCEEDED;
var SAVE_EDIT_FAILED = 'SAVE_EDIT_FAILED';
exports.SAVE_EDIT_FAILED = SAVE_EDIT_FAILED;
var RECALCULATE_IMAGE_DIMENSIONS_SUCCESS = 'RECALCULATE_IMAGE_DIMENSIONS_SUCCESS';
exports.RECALCULATE_IMAGE_DIMENSIONS_SUCCESS = RECALCULATE_IMAGE_DIMENSIONS_SUCCESS;
var DELETE_FILE_ATTEMPTED = 'DELETE_FILE_ATTEMPTED';
exports.DELETE_FILE_ATTEMPTED = DELETE_FILE_ATTEMPTED;
var DELETE_FILE_SUCCEEDED = 'DELETE_FILE_SUCCEEDED';
exports.DELETE_FILE_SUCCEEDED = DELETE_FILE_SUCCEEDED;
var DELETE_FILE_FAILED = 'DELETE_FILE_FAILED';
exports.DELETE_FILE_FAILED = DELETE_FILE_FAILED;
var ARCHIVE_FILE_ATTEMPTED = 'ARCHIVE_FILE_ATTEMPTED';
exports.ARCHIVE_FILE_ATTEMPTED = ARCHIVE_FILE_ATTEMPTED;
var ARCHIVE_FILE_SUCCEEDED = 'ARCHIVE_FILE_SUCCEEDED';
exports.ARCHIVE_FILE_SUCCEEDED = ARCHIVE_FILE_SUCCEEDED;
var ARCHIVE_FILE_FAILED = 'ARCHIVE_FILE_FAILED';
exports.ARCHIVE_FILE_FAILED = ARCHIVE_FILE_FAILED;
var UNARCHIVE_FILE_ATTEMPTED = 'UNARCHIVE_FILE_ATTEMPTED';
exports.UNARCHIVE_FILE_ATTEMPTED = UNARCHIVE_FILE_ATTEMPTED;
var UNARCHIVE_FILE_SUCCEEDED = 'UNARCHIVE_FILE_SUCCEEDED';
exports.UNARCHIVE_FILE_SUCCEEDED = UNARCHIVE_FILE_SUCCEEDED;
var UNARCHIVE_FILE_FAILED = 'UNARCHIVE_FILE_FAILED';
exports.UNARCHIVE_FILE_FAILED = UNARCHIVE_FILE_FAILED;
var MOVE_FILE_ATTEMPTED = 'MOVE_FILE_ATTEMPTED';
exports.MOVE_FILE_ATTEMPTED = MOVE_FILE_ATTEMPTED;
var MOVE_FILE_SUCCEEDED = 'MOVE_FILE_SUCCEEDED';
exports.MOVE_FILE_SUCCEEDED = MOVE_FILE_SUCCEEDED;
var MOVE_FILE_FAILED = 'MOVE_FILE_FAILED';
exports.MOVE_FILE_FAILED = MOVE_FILE_FAILED;
var RENAME_FILE_ATTEMPTED = 'RENAME_FILE_ATTEMPTED';
exports.RENAME_FILE_ATTEMPTED = RENAME_FILE_ATTEMPTED;
var RENAME_FILE_SUCCEEDED = 'RENAME_FILE_SUCCEEDED';
exports.RENAME_FILE_SUCCEEDED = RENAME_FILE_SUCCEEDED;
var RENAME_FILE_FAILED = 'RENAME_FILE_FAILED';
exports.RENAME_FILE_FAILED = RENAME_FILE_FAILED;
var FETCH_USER_SETTINGS_ATTEMPTED = 'FETCH_USER_SETTINGS_ATTEMPTED';
exports.FETCH_USER_SETTINGS_ATTEMPTED = FETCH_USER_SETTINGS_ATTEMPTED;
var FETCH_USER_SETTINGS_SUCCEEDED = 'FETCH_USER_SETTINGS_SUCCEEDED';
exports.FETCH_USER_SETTINGS_SUCCEEDED = FETCH_USER_SETTINGS_SUCCEEDED;
var FETCH_USER_SETTINGS_FAILED = 'FETCH_USER_SETTINGS_FAILED';
exports.FETCH_USER_SETTINGS_FAILED = FETCH_USER_SETTINGS_FAILED;
var FETCH_USER_SETTINGS_EMPTY = 'FETCH_USER_SETTINGS_EMPTY';
exports.FETCH_USER_SETTINGS_EMPTY = FETCH_USER_SETTINGS_EMPTY;
var SAVE_USER_SETTINGS_ATTEMPTED = 'SAVE_USER_SETTINGS_ATTEMPTED';
exports.SAVE_USER_SETTINGS_ATTEMPTED = SAVE_USER_SETTINGS_ATTEMPTED;
var UPDATE_VIDYARD_TOS_STATUS_ATTEMPTED = 'UPDATE_VIDYARD_TOS_STATUS_ATTEMPTED';
exports.UPDATE_VIDYARD_TOS_STATUS_ATTEMPTED = UPDATE_VIDYARD_TOS_STATUS_ATTEMPTED;
var UPDATE_VIDYARD_TOS_STATUS_SUCCEEDED = 'UPDATE_VIDYARD_TOS_STATUS_SUCCEEDED';
exports.UPDATE_VIDYARD_TOS_STATUS_SUCCEEDED = UPDATE_VIDYARD_TOS_STATUS_SUCCEEDED;
var UPDATE_VIDYARD_TOS_STATUS_FAILED = 'UPDATE_VIDYARD_TOS_STATUS_FAILED';
exports.UPDATE_VIDYARD_TOS_STATUS_FAILED = UPDATE_VIDYARD_TOS_STATUS_FAILED;
var FETCH_FILE_MANAGER_PORTAL_DATA_SUCCEEDED = 'FETCH_FILE_MANAGER_PORTAL_DATA_SUCCEEDED';
exports.FETCH_FILE_MANAGER_PORTAL_DATA_SUCCEEDED = FETCH_FILE_MANAGER_PORTAL_DATA_SUCCEEDED;
var UPDATE_PORTAL_META_ATTEMPTED = 'UPDATE_PORTAL_META_ATTEMPTED';
exports.UPDATE_PORTAL_META_ATTEMPTED = UPDATE_PORTAL_META_ATTEMPTED;
var UPDATE_PORTAL_META_SUCCEEDED = 'UPDATE_PORTAL_META_SUCCEEDED';
exports.UPDATE_PORTAL_META_SUCCEEDED = UPDATE_PORTAL_META_SUCCEEDED;
var UPDATE_PORTAL_META_FAILED = 'UPDATE_PORTAL_META_FAILED';
exports.UPDATE_PORTAL_META_FAILED = UPDATE_PORTAL_META_FAILED;
var INFERRED_USER_ROLE_FETCH_SUCCEEDED = 'INFERRED_USER_ROLE_FETCH_SUCCEEDED';
exports.INFERRED_USER_ROLE_FETCH_SUCCEEDED = INFERRED_USER_ROLE_FETCH_SUCCEEDED;
var CREATE_VIDYARD_PLAYERID_ATTEMPTED = 'CREATE_VIDYARD_PLAYERID_ATTEMPTED';
exports.CREATE_VIDYARD_PLAYERID_ATTEMPTED = CREATE_VIDYARD_PLAYERID_ATTEMPTED;
var CREATE_VIDYARD_PLAYERID_SUCCEEDED = 'CREATE_VIDYARD_PLAYERID_SUCCEEDED';
exports.CREATE_VIDYARD_PLAYERID_SUCCEEDED = CREATE_VIDYARD_PLAYERID_SUCCEEDED;
var CREATE_VIDYARD_PLAYERID_FAILED = 'CREATE_VIDYARD_PLAYERID_FAILED';
exports.CREATE_VIDYARD_PLAYERID_FAILED = CREATE_VIDYARD_PLAYERID_FAILED;
var SOFT_DELETE_VIDYARD_PLAYERID_FAILED = 'SOFT_DELETE_VIDYARD_PLAYERID_FAILED';
exports.SOFT_DELETE_VIDYARD_PLAYERID_FAILED = SOFT_DELETE_VIDYARD_PLAYERID_FAILED;
var SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED = 'SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED';
exports.SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED = SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED;
var CANVA_INIT_ATTEMPTED = 'CANVA_INIT_ATTEMPTED';
exports.CANVA_INIT_ATTEMPTED = CANVA_INIT_ATTEMPTED;
var CANVA_INIT_SUCCEEDED = 'CANVA_INIT_SUCCEEDED';
exports.CANVA_INIT_SUCCEEDED = CANVA_INIT_SUCCEEDED;
var CANVA_INIT_FAILED = 'CANVA_INIT_FAILED';
exports.CANVA_INIT_FAILED = CANVA_INIT_FAILED;
var DOWNLOAD_FROM_CANVA_ATTEMPTED = 'DOWNLOAD_FROM_CANVA_ATTEMPTED';
exports.DOWNLOAD_FROM_CANVA_ATTEMPTED = DOWNLOAD_FROM_CANVA_ATTEMPTED;
var DOWNLOAD_FROM_CANVA_SUCCEEDED = 'DOWNLOAD_FROM_CANVA_SUCCEEDED';
exports.DOWNLOAD_FROM_CANVA_SUCCEEDED = DOWNLOAD_FROM_CANVA_SUCCEEDED;
var DOWNLOAD_FROM_CANVA_FAILED = 'DOWNLOAD_FROM_CANVA_FAILED';
exports.DOWNLOAD_FROM_CANVA_FAILED = DOWNLOAD_FROM_CANVA_FAILED;
var REMOVE_CANVA_ID_SUCCEEDED = 'REMOVE_CANVA_ID_SUCCEEDED';
exports.REMOVE_CANVA_ID_SUCCEEDED = REMOVE_CANVA_ID_SUCCEEDED;
var DOWNLOAD_FROM_DROPBOX_ATTEMPTED = 'DOWNLOAD_FROM_DROPBOX_ATTEMPTED';
exports.DOWNLOAD_FROM_DROPBOX_ATTEMPTED = DOWNLOAD_FROM_DROPBOX_ATTEMPTED;
var DOWNLOAD_FROM_DROPBOX_SUCCEEDED = 'DOWNLOAD_FROM_DROPBOX_SUCCEEDED';
exports.DOWNLOAD_FROM_DROPBOX_SUCCEEDED = DOWNLOAD_FROM_DROPBOX_SUCCEEDED;
var DOWNLOAD_FROM_DROPBOX_FAILED = 'DOWNLOAD_FROM_DROPBOX_FAILED';
exports.DOWNLOAD_FROM_DROPBOX_FAILED = DOWNLOAD_FROM_DROPBOX_FAILED;
var DOWNLOAD_FROM_DRIVE_ATTEMPTED = 'DOWNLOAD_FROM_DRIVE_ATTEMPTED';
exports.DOWNLOAD_FROM_DRIVE_ATTEMPTED = DOWNLOAD_FROM_DRIVE_ATTEMPTED;
var DOWNLOAD_FROM_DRIVE_SUCCEEDED = 'DOWNLOAD_FROM_DRIVE_SUCCEEDED';
exports.DOWNLOAD_FROM_DRIVE_SUCCEEDED = DOWNLOAD_FROM_DRIVE_SUCCEEDED;
var DOWNLOAD_FROM_DRIVE_FAILED = 'DOWNLOAD_FROM_DRIVE_FAILED';
exports.DOWNLOAD_FROM_DRIVE_FAILED = DOWNLOAD_FROM_DRIVE_FAILED;
var DOWNLOAD_FROM_EXTERNAL_URL_ATTEMPTED = 'DOWNLOAD_FROM_EXTERNAL_URL_ATTEMPTED';
exports.DOWNLOAD_FROM_EXTERNAL_URL_ATTEMPTED = DOWNLOAD_FROM_EXTERNAL_URL_ATTEMPTED;
var DOWNLOAD_FROM_EXTERNAL_URL_SUCCEEDED = 'DOWNLOAD_FROM_EXTERNAL_URL_SUCCEEDED';
exports.DOWNLOAD_FROM_EXTERNAL_URL_SUCCEEDED = DOWNLOAD_FROM_EXTERNAL_URL_SUCCEEDED;
var VIDEO_THUMBNAIL_UPDATE_ATTEMPTED = 'VIDEO_THUMBNAIL_UPDATE_ATTEMPTED';
exports.VIDEO_THUMBNAIL_UPDATE_ATTEMPTED = VIDEO_THUMBNAIL_UPDATE_ATTEMPTED;
var VIDEO_THUMBNAIL_UPDATE_FAILED = 'VIDEO_THUMBNAIL_UPDATE_FAILED';
exports.VIDEO_THUMBNAIL_UPDATE_FAILED = VIDEO_THUMBNAIL_UPDATE_FAILED;
var VIDEO_THUMBNAIL_UPDATE_SUCCEEDED = 'VIDEO_THUMBNAIL_UPDATE_SUCCEEDED';
exports.VIDEO_THUMBNAIL_UPDATE_SUCCEEDED = VIDEO_THUMBNAIL_UPDATE_SUCCEEDED;
var GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_ATTEMPTED = 'GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_ATTEMPTED';
exports.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_ATTEMPTED = GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_ATTEMPTED;
var GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_FAILED = 'GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_FAILED';
exports.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_FAILED = GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_FAILED;
var GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED = 'GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED';
exports.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED = GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED;
var FETCH_LIMITS_SUCCEEDED = 'FETCH_LIMITS_SUCCEEDED';
exports.FETCH_LIMITS_SUCCEEDED = FETCH_LIMITS_SUCCEEDED;
var CONFIRM_VIDEO_UPLOAD_WITHOUT_EMBED = 'CONFIRM_VIDEO_UPLOAD_WITHOUT_EMBED';
exports.CONFIRM_VIDEO_UPLOAD_WITHOUT_EMBED = CONFIRM_VIDEO_UPLOAD_WITHOUT_EMBED;
var DECREASE_VIDEO_QUANTITY_USED = 'DECREASE_VIDEO_QUANTITY_USED';
exports.DECREASE_VIDEO_QUANTITY_USED = DECREASE_VIDEO_QUANTITY_USED;
var SELECT_FILE = 'SELECT_FILE';
exports.SELECT_FILE = SELECT_FILE;
var IMAGE_TO_EDIT_SELECTED = 'IMAGE_TO_EDIT_SELECTED';
exports.IMAGE_TO_EDIT_SELECTED = IMAGE_TO_EDIT_SELECTED;
var IMAGE_TO_EDIT_DESELECTED = 'IMAGE_TO_EDIT_DESELECTED';
exports.IMAGE_TO_EDIT_DESELECTED = IMAGE_TO_EDIT_DESELECTED;
var UPLOAD_EDITED_IMAGE_ATTEMPTED = 'UPLOAD_EDITED_IMAGE_ATTEMPTED';
exports.UPLOAD_EDITED_IMAGE_ATTEMPTED = UPLOAD_EDITED_IMAGE_ATTEMPTED;
var UPLOAD_EDITED_IMAGE_FAILED = 'UPLOAD_EDITED_IMAGE_FAILED';
exports.UPLOAD_EDITED_IMAGE_FAILED = UPLOAD_EDITED_IMAGE_FAILED;
var UPLOAD_EDITED_IMAGE_SUCCEEDED = 'UPLOAD_EDITED_IMAGE_SUCCEEDED';
exports.UPLOAD_EDITED_IMAGE_SUCCEEDED = UPLOAD_EDITED_IMAGE_SUCCEEDED;
var HUB_USERS_FETCH_SUCCEEDED = 'HUB_USERS_FETCH_SUCCEEDED';
exports.HUB_USERS_FETCH_SUCCEEDED = HUB_USERS_FETCH_SUCCEEDED;
var HUB_USERS_FETCH_FAILED = 'HUB_USERS_FETCH_FAILED';
exports.HUB_USERS_FETCH_FAILED = HUB_USERS_FETCH_FAILED;
var FETCH_SIGNED_URL_FAILED = 'FETCH_SIGNED_URL_FAILED';
exports.FETCH_SIGNED_URL_FAILED = FETCH_SIGNED_URL_FAILED;
var SEARCH_SHUTTERSTOCK_RESET = 'SEARCH_SHUTTERSTOCK_RESET';
exports.SEARCH_SHUTTERSTOCK_RESET = SEARCH_SHUTTERSTOCK_RESET;
var SEARCH_SHUTTERSTOCK_ATTEMPTED = 'SEARCH_SHUTTERSTOCK_ATTEMPTED';
exports.SEARCH_SHUTTERSTOCK_ATTEMPTED = SEARCH_SHUTTERSTOCK_ATTEMPTED;
var SEARCH_SHUTTERSTOCK_SUCCEEDED = 'SEARCH_SHUTTERSTOCK_SUCCEEDED';
exports.SEARCH_SHUTTERSTOCK_SUCCEEDED = SEARCH_SHUTTERSTOCK_SUCCEEDED;
var SEARCH_SHUTTERSTOCK_FAILED = 'SEARCH_SHUTTERSTOCK_FAILED';
exports.SEARCH_SHUTTERSTOCK_FAILED = SEARCH_SHUTTERSTOCK_FAILED;
var ACQUIRE_IMAGE_ATTEMPTED = 'ACQUIRE_IMAGE_ATTEMPTED';
exports.ACQUIRE_IMAGE_ATTEMPTED = ACQUIRE_IMAGE_ATTEMPTED;
var ACQUIRE_IMAGE_SUCCEEDED = 'ACQUIRE_IMAGE_SUCCEEDED';
exports.ACQUIRE_IMAGE_SUCCEEDED = ACQUIRE_IMAGE_SUCCEEDED;
var ACQUIRE_IMAGE_FAILED = 'ACQUIRE_IMAGE_FAILED';
exports.ACQUIRE_IMAGE_FAILED = ACQUIRE_IMAGE_FAILED;
var RESET_PAGE = 'RESET_PAGE';
exports.RESET_PAGE = RESET_PAGE;
var CHANGE_TAB = 'CHANGE_TAB';
exports.CHANGE_TAB = CHANGE_TAB;
var CHANGE_FILE_ACCESSIBILITY_REQUEST_SUCCEEDED = 'CHANGE_FILE_ACCESSIBILITY_REQUEST_SUCCEEDED';
exports.CHANGE_FILE_ACCESSIBILITY_REQUEST_SUCCEEDED = CHANGE_FILE_ACCESSIBILITY_REQUEST_SUCCEEDED;
var TRACK_INTERACTION = 'TRACK_INTERACTION';
exports.TRACK_INTERACTION = TRACK_INTERACTION;
var FETCH_SUSPENSION_STATE_ATTEMPTED = 'FETCH_SUSPENSION_STATE_ATTEMPTED';
exports.FETCH_SUSPENSION_STATE_ATTEMPTED = FETCH_SUSPENSION_STATE_ATTEMPTED;
var FETCH_SUSPENSION_STATE_SUCCEEDED = 'FETCH_SUSPENSION_STATE_SUCCEEDED';
exports.FETCH_SUSPENSION_STATE_SUCCEEDED = FETCH_SUSPENSION_STATE_SUCCEEDED;
var FETCH_SUSPENSION_STATE_FAILED = 'FETCH_SUSPENSION_STATE_FAILED';
exports.FETCH_SUSPENSION_STATE_FAILED = FETCH_SUSPENSION_STATE_FAILED;